import React, { useEffect, useState } from 'react'
import { Divider, Grid, Paper, IconButton, Modal } from '@mui/material'
import styles from './DailyJournal.module.scss'
import moment from 'moment/moment'
import ReactHtmlParser from 'react-html-parser'

import Calendar from '../Calendar'
import { IconApp } from '../IconApp/IconApp'
import JournalModal from './JournalModal'
import CalendarModal from './CalendarModal'
import { ConfirmationModal } from '../ActivitiesList/ConfirmationModal'

const DailyJournal = ({
  isSelectedByCalendar,
  selectedDate,
  handleSelectDate,
  handleSelectDateFromCalendar,
  dailys,
  handleMove,
  handleSaveDailys,
  handleEditDailys,
  handleDeleteDaily,
  recurringFeelingsData,
  handleSelectFeeling,
  action,
  logout,
  isLoadingDeleteJournal,
  isSuccessDeleteJournal
}) => {
  const [showAdd, setShowAdd] = useState(false)
  const [showCalendar, setShowCalendar] = useState(false)
  const [dailyTextHTML, setDailyText] = useState(null)
  const [defaultValue, setDefaultValue] = useState(null)
  const [isEdition, setIsEdition] = useState(false)
  const [idToEdit, setIdToEdit] = useState(null)
  const [confirmDelete, setConfirmDelete] = useState(false)

  useEffect(() => {
    if (isSuccessDeleteJournal) {
      setConfirmDelete(false)
    }
  }, [isSuccessDeleteJournal])

  const handleAddActivity = () => {
    setIsEdition(false)
    setDefaultValue(null)
    setShowAdd(true)
  }
  const handleClose = () => {
    setShowAdd(false)
  }
  const handleSave = () => {
    handleSaveDailys(dailyTextHTML)
    setShowAdd(false)
  }

  const handleEdit = () => {
    handleEditDailys(idToEdit, dailyTextHTML)
    setShowAdd(false)
  }

  const handleCloseDelete = () => {
    setConfirmDelete(false)
  }

  const handleDelete = () => {
    setConfirmDelete(true)
  }

  const handleConfirmDelete = () => {
    handleDeleteDaily(idToEdit)
    setShowAdd(false)
  }

  const handleChange = (event) => {
    setDailyText(event)
  }

  const handleEditActivity = (daily) => {
    setIsEdition(true)
    setDefaultValue(daily.text)
    setIdToEdit(daily.id)
    setShowAdd(true)
  }

  const handleOpenCalendar = () => {
    setShowCalendar(true)
  }
  const handleCloseCalendar = () => {
    setShowCalendar(false)
  }

  const handleChangeDate = (value) => {
    setShowCalendar(false)
    handleSelectDateFromCalendar(moment(value)._i.$d)
  }

  const getLimitText = (txt) => {
    if ([...txt].length > 50) {
      return `${txt.substring(0, 50)}...`
    }
    return txt
  }

  const modalDeleteInfo = {
    title: 'Are you sure you want to delete this journal entry?',
    cancelText: 'Cancel',
    okText: 'Delete',
  }


  useEffect(() => {
    if (logout) {
      if (isEdition) {
        handleEdit()
      } else {
        handleSave()
      }
    }

  }, [logout, isEdition])

  return (
    <>
      <div>
        <Modal open={showAdd} onClose={handleClose}>
          <JournalModal
            defaultValue={defaultValue}
            isEdition={isEdition}
            handleClose={handleClose}
            handleChange={handleChange}
            handleSave={handleSave}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </Modal>
        <Modal open={confirmDelete} onClose={handleCloseDelete}>
          <ConfirmationModal
            handleClose={handleCloseDelete}
            handleDelete={handleConfirmDelete}
            modalInfo={modalDeleteInfo}
            isLoadingDeleteActivity={isLoadingDeleteJournal}
          />
        </Modal>
        <Modal open={showCalendar} onClose={handleCloseCalendar}>
          <CalendarModal handleChangeDate={handleChangeDate} />
        </Modal>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.wrapperTop}>
          <div className={styles.wrapperTitle}>
            <div className={styles.dailyTitle}>
              {moment(selectedDate).format('dddd, MMMM D, YYYY')}
            </div>
            <IconButton onClick={handleOpenCalendar}>
              <IconApp height="17px" iconName="calendar" alt="calendar" />
            </IconButton>
          </div>
          <Calendar
            isSelectedByCalendar={isSelectedByCalendar}
            handleMove={handleMove}
            recurringFeelingsData={recurringFeelingsData}
            selectedDate={selectedDate}
            handleSelectDate={handleSelectDate}
            handleSelectFeeling={handleSelectFeeling}
            action={action}
          />
        </div>
        <div className={styles.wrapperBottom}>
          <div className={styles.dailyTitle}>Daily Journal</div>
          <div className={styles.wrapperJournal}>
            <div className={styles.wrapperIconButton}>
              <IconButton
                className={styles.addIconButton}
                onClick={handleAddActivity}
              >
                <IconApp iconName="plus" alt="plus" />
              </IconButton>
            </div>

            {dailys.map((ele, indx) => (
              <div key={indx} className={styles.dailyLine}>
                <Divider flexItem style={{ borderColor: "#080C0A", height: "0.5px" }}/>
                <Grid className={styles.containerText} container spacing={0.5}>
                  <Grid item sm={3}>
                    <Paper className={styles.hour}>{ele.hour}</Paper>
                    {ele.hour && (
                      <IconButton
                        className={styles.editButton}
                        onClick={() => handleEditActivity(ele)}
                      >
                        <IconApp
                          width="11px"
                          iconName="edit-icon-MUA"
                          alt="edit-icon-MUA"
                        />
                      </IconButton>
                    )}
                  </Grid>
                  <Grid item sm={9}>
                    <Paper className={styles.text}>
                      {ele.text && ReactHtmlParser(getLimitText(ele.text))}
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default DailyJournal
